<div class="row">

	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="add()"
				*ngIf="project?.isDraft">
				<i
					container="body"
					ngbTooltip="{{'labels.add-employee' | translate}}"
					class="feather icon-edit"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					[messages]="{
          emptyMessage: 'labels.empty-employees' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<!-- ID -->
					<ngx-datatable-column
						[flexGrow]="0.5"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{row.employee.id}}
						</ng-template>
					</ngx-datatable-column>

					<!-- NOME -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								class="link"
								routerLink="/company/employee/view/{{row.employee.id}}"
								ngbTooltip="{{'labels.employee-details' | translate}}">
								{{row.employee.fname}}
							</a>
						</ng-template>
					</ngx-datatable-column>
					<!-- COGNOME -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.lname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{ row.employee.lname}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="docvalid"
						[flexGrow]="0.5"
						[name]="''"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<i
								*ngIf="row.employee.docvalid"
								container="body"
								ngbTooltip="{{'labels.docvalid' | translate}}"
								class="icon-valid feather icon-check-circle"></i>

							<i
								*ngIf="!row.employee.docvalid"
								container="body"
								ngbTooltip="{{'labels.docinvalid' | translate}}"
								class="icon-invalid feather icon-alert-octagon"></i>
						</ng-template>
					</ngx-datatable-column>

					<!-- AZIENDA -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.company' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>

							<a
								routerLink="/company/view/{{row.employee.company.id}}"
								class="link"
								ngbTooltip="{{'labels.company-details' | translate}}">
								{{row.employee.company.name}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<!-- CODICE FISCALE -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.cf' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{row.employee.cf}}
						</ng-template>
					</ngx-datatable-column>

					<!-- projectrole -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.projectrole' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{row.projectrole}}
						</ng-template>
					</ngx-datatable-column>

					<!-- Responsabile Scientifico -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'partecipant.manager' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<a
									(click)="updateManager(row)"
									class="link">
									<i
										*ngIf="row.employee.id === partecipant?.manager"
										container="body"
										class="far fa-check-square"></i>
									<i
										*ngIf="row.employee.id !== partecipant?.manager"
										container="body"
										class="far fa-square"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									(click)="openFileGeneratorModal(row,fileGeneratorModal)"
									class="link"
									*ngIf="project?.isDraft">
									<i
										container="body"
										ngbTooltip="Genera moduli"
										class="feather icon-file"></i>
								</a>

								<a
									(click)="delete(row)"
									class="link"
									*ngIf="project?.isDraft">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>

<ng-template
	#fileGeneratorModal
	let-modal>
	<div class="modal-header">
		<h4
			class="modal-title"
			id="modal-basic-title">
			Moduli {{selectedProjectEmployee.fullname}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div class="modal-body">

		<app-doc-template-generate
			[tenderid]="tenderid"
			[entityname]="selectedProjectEmployee.fullname"
			entity="employee"
			[eid]="selectedProjectEmployee.id"></app-doc-template-generate>

	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-outline-dark"
			(click)="modal.close('Save click')">
			{{'labels.close' | translate}}
		</button>
	</div>
</ng-template>
